import { render } from "./comheader.vue?vue&type=template&id=bd671a66&scoped=true"
const script = {}

import "./comheader.vue?vue&type=style&index=0&id=bd671a66&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd671a66"]])

export default __exports__